module.exports = __webpack_public_path__ + "static/media/letters.27734a97.svg";